import { Component } from '@angular/core';

@Component({
  selector: 'ui-card-page',
  templateUrl: './ui-card-page.component.html',
  styleUrls: ['./ui-card-page.component.scss'],
})
export class UICardContainerComponent {
}
